module.exports = __webpack_public_path__ + "media/images/help/delivery/eyecatch-point-01-9f09c62b296330b709d917ce4d882a5f.png";